export default __webpack_public_path__ + "static/media/logo_transparent.82cf9dcc.png";